module.exports = "https://web-assets-production.autolist.com/_next/static/images/escaperoom-48a52833580607476ed2b8b4c7aed446.jpg";